import React from 'react';
import { ButtonPrimary } from '../../../utils/Button';
import { GetDate } from '../../../utils/Show';
import cn from '../../../utils/cn';
import { useApiAccessToken } from '../ApiAccessTokenProvider';

function TableInfoCard({ name, value, isCapitalize, className }) {
    return (
        <div
            className={cn(
                'text-sm text-primary-700 font-medium flex flex-row gap-3 justify-start items-center h-5',
                className
            )}
        >
            <p className="inline-flex justify-between items-center min-w-[112px] w-28">
                <span>{name}</span>
                <span>:</span>
            </p>
            <span
                className={cn(`line-clamp-1 text-primary font-normal text-sm`, {
                    capitalize: isCapitalize
                })}
            >
                {value}
            </span>
        </div>
    );
}

function TableRow({ item }) {
    const { handleDeleteToken } = useApiAccessToken();
    const [isTrActive, setIsTrActive] = React.useState(false);

    return (
        <div
            tabIndex={-1}
            role="button"
            onClick={() => setIsTrActive((cu) => !cu)}
            className={cn(
                `table-visible-data overflow-hidden w-full flex flex-col justify-between text-primary p-2.5 rounded-md transition-all duration-[800ms] ease-in-out remove-highlight`,
                {
                    'max-h-72': isTrActive,
                    'max-h-10': !isTrActive,
                    'placeholder-mode': item.demo
                }
            )}
        >
            <div className="w-full flex flex-row gap-1 justify-between text-primary text-sm font-medium leading-normal">
                <div className="min-w-[112px] w-28">
                    <span>{item?.id}</span>
                </div>
                <div className="w-full">
                    <span className="line-clamp-1">{item?.tokenName}</span>
                </div>
                <div className="w-full hidden sm:block">
                    <span className="line-clamp-1 capitalize">{item?.user?.organization}</span>
                </div>
            </div>

            <div className="table-data-more mt-3.5 flex flex-col justify-start items-item gap-2">
                <TableInfoCard
                    name="User Name"
                    value={item?.user?.organization}
                    isCapitalize
                    className="sm:hidden"
                />
                <TableInfoCard name="Email" value={item?.user?.primaryEmail || '--'} />
                <TableInfoCard name="Description" value={item?.description || '--'} />
                <TableInfoCard
                    name="Date Created"
                    value={GetDate(item?.timeCreated)}
                    isCapitalize
                />
                <TableInfoCard name="Date Expire" value={GetDate(item?.timeExpire)} isCapitalize />
                <TableInfoCard
                    name="Status"
                    value={
                        item?.status ? (
                            <span className="text-success">{item?.status}</span>
                        ) : (
                            <span className="text-error">{item?.status}</span>
                        )
                    }
                    isCapitalize
                />

                <div className="flex flex-row flex-wrap gap-px justify-end items-center">
                    <ButtonPrimary
                        btnType="button"
                        title="Delete"
                        onClick={(ev) => handleDeleteToken(ev, item)}
                    />
                </div>
            </div>
        </div>
    );
}

function ApiAccessTokenBodyMobile() {
    const { accessTokenData } = useApiAccessToken();

    return (
        <div className="api_access_token_page_table">
            <div className="table-data [&>*:nth-child(odd)]:bg-primary-50">
                {accessTokenData?.tokenList && accessTokenData?.tokenList?.length === 0 ? (
                    <div className="w-full text-sm font-medium p-2 rounded-5">No Data Found</div>
                ) : (
                    accessTokenData?.tokenList?.map((item) => (
                        <TableRow key={item.id} item={item} />
                    ))
                )}
            </div>
        </div>
    );
}

export default ApiAccessTokenBodyMobile;
